import React from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CustomButton, Footer } from "src/app/components";
import { EymemoryRoutes } from "src/app/navigation/routes";
import LocalImages from "../../static";

const OrderErrorScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const orderHash = searchParams.get("orderHash") || location?.state?.orderHash;

  return (
    <div className="main-wrapper bg-white container">
      <div className="d-flex flex-column flex-grow-1 mg-b-20 mg-b-xs-50 justify-content-center">
        <div className="mg-b-md-30 mg-b-xs-50 mg-t-md-100 mg-t-xs-50 pd-t-xs-0 d-flex justify-content-center flex-column align-items-center">
          <img
            src={LocalImages.eyMemoriesLogo}
            alt="logo"
            className="eymemories-logo"
          />
          <img
            src={LocalImages.eyMemoriesAbstract}
            alt="download icon"
            className="download-icon mg-t-30"
          />
        </div>
        {orderHash ? (
          <div className="flex-1 d-flex flex-column justify-content-center align-items-center">
            <div className="downloading-content text-center w-100">
              <p className="fs-5 fs-18 text-black fw-bold mg-b-5">
                Your session has expired.
              </p>
              <p className="fs-14 text-black mg-b-28">
                Press continue to access your order.
              </p>
              <CustomButton
                text="Continue"
                color="primary"
                customBtnStyle="downloading-content-btn"
                onClick={() => {
                  navigate(
                    `${EymemoryRoutes.EYMEMORIES_DOWNLOAD_LINK}/${orderHash}`
                  );
                }}
              />
            </div>
          </div>
        ) : (
          <div className="text-center">
            <p className="fs-5 fs-18 text-black fw-bold mg-b-5">
              Your session has expired.
            </p>
            <p className="fs-14 text-black mg-b-28">
              Please use the order link from your email to access your order.
            </p>
          </div>
        )}
      </div>
      <div className="mg-b-10">
        <Footer />
      </div>
    </div>
  );
};

export default OrderErrorScreen;
